import React from "react";
import { Spin } from "antd";
import { useParams, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import useEffectOnce from '../../utils/useEffectOnce';

interface LoginUrlParams {
    SAMLRequest?: string;
    RelayState?: string;
    [key: string]: any; 
}
// 处理阿里云、火山引擎、华为云、蓝湖、mastergo的sp参数逻辑，并重定向到登录首页
const LoginSp: any = () => {
    const navigate = useNavigate();
    const { type } = useParams();
    const params: LoginUrlParams = queryString.parse(window.location.search.split('?')[1] || '');
    const urlParams = {
        ...params,
        sp: type
    };

    useEffectOnce(() => {
        navigate(`/login?${queryString.stringify(urlParams)}`, { replace: true });
    });

    return <Spin size="large" style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }} tip="Loading..."></Spin>
};

export default LoginSp;